import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { extraSmall, medium, small } from 'utils';

export const BookingAlertContainer = styled.div`
  margin-bottom: 40px;
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  place-items: center;

  ${extraSmall(css`
    place-items: flex-start;
  `)};

  ${small(css`
    place-items: flex-start;
    grid-template-columns: minmax(0, 200px) 1fr;
    grid-gap: 40px;
  `)};

  ${medium(css`
    grid-template-columns: minmax(0, 287px) 1fr;
  `)};
`;

export const StickyColumn = styled.div`
  display: flex;
  flex-direction: column;

  .practitioner-avatar {
    margin-bottom: ${rem(20)};
  }

  ${small(css`
    min-width: ${rem(200)};
    position: sticky;
    top: ${rem(12)};
  `)}

  @media screen and (min-width: 834px) {
    top: ${rem(32)};
  }

  ${medium(css`
    min-width: ${rem(287)};
  `)}
`;
